import JxSelect from '../../../JxControls/JxSelect/JxSelect';

/**
 * Dropdown control for settings rows.
 * Thin wrapper around JxSelect — keeps SettingsTab.jsx call sites unchanged.
 * @param {object} props
 * @param {string} props.value
 * @param {function} props.onChange - fn(value)
 * @param {{ label: string, value: string }[]} props.options
 */
export default function SettingsDropdown({ value, onChange, options }) {
    return <JxSelect value={value} onChange={onChange} options={options} defaultLabel="Select…" />;
}
